// const processArabicText = (text) => {
//   const isPara = /\(.*?\)/.test(text);
//   const content =
//     text?.replace(/\(([^)]+)\)/g, '<span class="parens-fix">$1</span>') || "";
//   return { isPara, content };
// };


export const processArabicText = (text, plainText = false) => {
  if (!text) return plainText ? "" : [];
  
  const regex = /\(([^)]+)\)/g;
  let lastIndex = 0;
  let match;
  const parts = [];

  if (plainText) {
    // Return plain HTML string for dangerouslySetInnerHTML
    return text.replace(/\(([^)]+)\)/g, '<span class="parens-fix">$1</span>');
  } else {
    // Return React components array (default behavior)
    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }
      parts.push(
        <span key={match.index} className="parens-fix">
          {match[1]}
        </span>
      );

      lastIndex = regex.lastIndex;
    }
    
    if (lastIndex < text?.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts.length > 0 ? parts : [text];
  }
};
